import { default as Obj } from "./abstract/Object";
import * as intersection from 'lodash/intersection';

const uniqueify = function(arr) {
  var a = arr.concat();
  for(var i=0; i<a.length; ++i) {
      for(var j=i+1; j<a.length; ++j) {
          if(a[i] === a[j])
              a.splice(j--, 1);
      }
  }

  return a;
};


export default class FilterItem extends Obj {

  filter_child;

  name;
  key;
  type;
  options_all;
  options;

  text_when_null;

  state = {
    text: '',
    value: null
  }

  ref;

  constructor(props) {
    super();

    this.initializeAttributes(props, {
      items: (value) => Filter.list(value),
    });

    if (!this.state) {
      this.state = {
        text: '',
        value: null
      }
    }

    if (!this.options_all && this.options) {
      this.options_all = [...this.options];
    }
  }

  filterOptions(key, selectedParentIds) {
    this.options = this.options.filter(option => {
      const parentIds = Array.isArray(option.data[key]) ? option.data[key] : [option.data[key]]; // Gets the list of parent parentIds to which the child responds

      for (let i = 0; i < selectedParentIds.length; i++) {
        const parentId = selectedParentIds[i];
        if (parentIds.indexOf(parentId) > -1) return true; // If one of the parent ids is in the list, keep this option
      }

      option.selection = false; // If not, deselect the option and remove the option
      return false;
    })
  }

  removeOptions(values) {
    this.options = this.options.filter(option => values.indexOf(option.value + '') == -1);
  }

  appendValue(value) {
    if (Array.isArray(this.state.value)) {
      const arr = Array.isArray(value) ? this.state.value.concat(value) : this.state.value.push(value);
      this.state.value = uniqueify(arr);
    } else {
      this.state.value = value;
    }
  }

  updateSelection() {
    if (this.type == 'checkbox' || this.type == 'toggle') {
      this.options.forEach(option => {
        option.selection = (!this.state.value && this.auto_select_all !== false) ||
          (this.state.value &&
            (this.state.value.indexOf(option.value + '') > -1 || this.state.value.indexOf(option.value) > -1)
          );
      });
    } else if (this.type == 'radio') {
      this.options.forEach(option => {
        option.selection = this.state.value == option.value;
      });
    } else {
      this.state.text = this.state.value;
    }
  }

  updateState() {
    if (this.type == 'checkbox' || this.type == 'toggle') {
      const selectedItems = this.options.filter(item => item.selection ? true : false);
      this.state.value = selectedItems.map(item => item.value);

      if (selectedItems.length != this.options.length) {
        this.state.text = selectedItems.map(item => item.text).join(', ');
      } else {
        this.state.text = this.text_when_all;
      }
    } else if (this.type == 'radio') {
      const item = this.options.find(item => item.selection)
      this.state.text = item ? item.text : null
      this.state.value = item ? item.value : null;
    } else {
      this.state.text = this.state.value;
    }

    if (this.state.value == null || (this.state.value && this.state.value.length === 0)) {
      this.state.text = this.text_when_null;
    }
  }

  ignoreToJson() {
    return ['ref'];
  }
}
